module.exports = __webpack_public_path__ + "img/abstract-shapes-12-naked.2bf2fb93.svg";